import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IAidasUpload } from 'app/shared/model/ainnotateservice/aidas-upload.model';
import { getEntities as getAidasUploads } from 'app/entities/ainnotateservice/aidas-upload/aidas-upload.reducer';
import { getEntity, updateEntity, createEntity, reset } from './aidas-upload-meta-data.reducer';
import { IAidasUploadMetaData } from 'app/shared/model/ainnotateservice/aidas-upload-meta-data.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasUploadMetaDataUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasUploads = useAppSelector(state => state.aidasUpload.entities);
  const aidasUploadMetaDataEntity = useAppSelector(state => state.aidasUploadMetaData.entity);
  const loading = useAppSelector(state => state.aidasUploadMetaData.loading);
  const updating = useAppSelector(state => state.aidasUploadMetaData.updating);
  const updateSuccess = useAppSelector(state => state.aidasUploadMetaData.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-upload-meta-data' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasUploads({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...aidasUploadMetaDataEntity,
      ...values,
      aidasUpload: aidasUploads.find(it => it.id.toString() === values.aidasUploadId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...aidasUploadMetaDataEntity,
          aidasUploadId: aidasUploadMetaDataEntity?.aidasUpload?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="ainnotategwApp.ainnotateserviceAidasUploadMetaData.home.createOrEditLabel"
            data-cy="AidasUploadMetaDataCreateUpdateHeading"
          >
            Create or edit a AidasUploadMetaData
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="aidas-upload-meta-data-id" label="ID" validate={{ required: true }} />
              ) : null}
              <ValidatedField label="Name" id="aidas-upload-meta-data-name" name="name" data-cy="name" type="text" />
              <ValidatedField label="Value" id="aidas-upload-meta-data-value" name="value" data-cy="value" type="text" />
              <ValidatedField
                id="aidas-upload-meta-data-aidasUpload"
                name="aidasUploadId"
                data-cy="aidasUpload"
                label="Aidas Upload"
                type="select"
              >
                <option value="" key="0" />
                {aidasUploads
                  ? aidasUploads.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/aidas-upload-meta-data" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasUploadMetaDataUpdate;
